export const urls = {
    footer : {
        運営会社 : 'https://netamoto.co.jp/company/profile/',
        利用規約 : 'https://c.netamoto.jp/rules/company_index.html',
        個人情報保護方針 : 'https://netamoto.co.jp/privacy/',
    },
}
